import { Link } from "react-router-dom";
import BrandLogo from "@/components/BrandLogo";

export default function Pdpa() {
  return (
    <div className="auth-shell">
      <div className="auth-panel-left">
        <div className="auth-brand">
          <BrandLogo variant="auth" />
          <div className="auth-brand-desc">
            Personal Data Protection Act 2010 (PDPA) notice for PERCASA Residence Management.
          </div>
        </div>
      </div>

      <div className="auth-panel-right" style={{ overflowY: "auto", maxHeight: "100vh" }}>
        <div className="auth-form-title" data-testid="pdpa-page-title">PDPA Notice</div>
        <div className="auth-form-sub">Personal Data Protection Act 2010</div>

        <div style={{ fontSize: 13, color: "var(--text)", lineHeight: 1.65 }} data-testid="pdpa-content">
          <p style={{ marginBottom: 14 }}>
            This notice explains how <strong>PERCASA Residence Management</strong> (“we”, “us”)
            collects, uses, and protects your personal data when you register for and use the
            PERCASA resident portal, in accordance with the Personal Data Protection Act 2010 (PDPA)
            of Malaysia.
          </p>

          <h3 style={{ fontSize: 14, margin: "18px 0 8px", color: "var(--brand-dark)" }}>1. Data we collect</h3>
          <p style={{ marginBottom: 10 }}>We may collect the following information from you:</p>
          <ul style={{ margin: "0 0 14px 18px", padding: 0 }}>
            <li>Full name</li>
            <li>Email address and phone number</li>
            <li>House number and street (unit details)</li>
            <li>Login credentials (username and password)</li>
            <li>Payment and maintenance fee records related to your unit</li>
            <li>Visitor or security-related information you submit through the portal</li>
          </ul>

          <h3 style={{ fontSize: 14, margin: "18px 0 8px", color: "var(--brand-dark)" }}>2. Purpose of processing</h3>
          <p style={{ marginBottom: 10 }}>Your personal data is processed for:</p>
          <ul style={{ margin: "0 0 14px 18px", padding: 0 }}>
            <li>Resident account registration and authentication</li>
            <li>Residence and community management</li>
            <li>Maintenance fee, sticker fee, and related payment processing</li>
            <li>Community notices, reminders, and operational communication</li>
            <li>Security, access control, and visitor management (where applicable)</li>
            <li>Compliance with legal or regulatory obligations</li>
          </ul>

          <h3 style={{ fontSize: 14, margin: "18px 0 8px", color: "var(--brand-dark)" }}>3. Disclosure</h3>
          <p style={{ marginBottom: 14 }}>
            We may share your data with authorised committee members, service providers (such as
            payment gateways and hosting providers), or authorities when required by law. We do not
            sell your personal data to third parties.
          </p>

          <h3 style={{ fontSize: 14, margin: "18px 0 8px", color: "var(--brand-dark)" }}>4. Storage and security</h3>
          <p style={{ marginBottom: 14 }}>
            Personal data is stored securely using reasonable technical and organisational measures.
            Access is limited to authorised personnel for legitimate management purposes.
          </p>

          <h3 style={{ fontSize: 14, margin: "18px 0 8px", color: "var(--brand-dark)" }}>5. Your rights</h3>
          <p style={{ marginBottom: 14 }}>
            Subject to the PDPA, you may request access to, correction of, or limitation on the
            processing of your personal data. To exercise these rights, contact PERCASA Residence
            Management / your JKKK committee through the official residence channels.
          </p>

          <h3 style={{ fontSize: 14, margin: "18px 0 8px", color: "var(--brand-dark)" }}>6. Consent</h3>
          <p style={{ marginBottom: 14 }}>
            By registering an account and accepting this notice, you consent to the collection and
            processing of your personal data for the purposes stated above. You may withdraw consent
            by contacting the committee; withdrawal may affect your ability to use certain portal
            services.
          </p>

          <p style={{ marginBottom: 18, color: "var(--text2)", fontSize: 12 }}>
            Last updated: August 2026
          </p>
        </div>

        <div className="auth-link" style={{ marginTop: 8 }}>
          <Link to="/register" data-testid="pdpa-back-register">← Back to registration</Link>
          {" · "}
          <Link to="/login" data-testid="pdpa-login-link">Sign in</Link>
        </div>
      </div>
    </div>
  );
}
